export default __webpack_public_path__ + "static/media/17-min.cc2211d7.jpg";